app.component('topLink', {
    templateUrl: 'app/common/component/toplink/toplink.html',
    controller: function ($location) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            $ctrl.goLeftPath = function() {
                $location.path($ctrl.leftPath);
            }
            $ctrl.goRightPath = function() {
                $location.path($ctrl.rightPath);
            }
        };
    },
    bindings: {
        className : '@',
        leftText : '@',
        leftPath : '@',
        centerText : '@',
        centerImage : '@',
        rightText : '@',
        rightPath : '@'
    }
});
